import { HomePageMinorSection, TopSectionWithoutSubtitle } from '../template.state.types';
import { SECTION_NAMES } from '../../../templates/templates.const';

export type HomePageTopSection = typeof SECTION_NAMES.TOP_SECTION
export type HomePageMinorSections =
  typeof SECTION_NAMES.CARDS_SECTION
  | typeof SECTION_NAMES.CONTENT_SECTION_1
  | typeof SECTION_NAMES.CONTENT_SECTION_2
  | typeof SECTION_NAMES.CONTENT_SECTION_3
export type SectionNames = HomePageTopSection | HomePageMinorSections;

export interface HomePageState {
  [SECTION_NAMES.TOP_SECTION]: TopSectionWithoutSubtitle;
  [SECTION_NAMES.CARDS_SECTION]: HomePageMinorSection;
  [SECTION_NAMES.CONTENT_SECTION_1]: HomePageMinorSection;
  [SECTION_NAMES.CONTENT_SECTION_2]: HomePageMinorSection;
  [SECTION_NAMES.CONTENT_SECTION_3]: HomePageMinorSection;
  metadataDescription: string;
  metadataTitle: string;
  metadataAdsCategory: string | null;
}

export type HomePageAction = { type: string };

export const homePageReducer = (state: HomePageState = {} as HomePageState, action: HomePageAction) => {
  switch (action.type) {
    default:
      return state;
  }
};
